import { gql } from '@apollo/client';

export const SHOW_AD_TRACKER = gql`
  query ShowAdTracker($trackingProfileId: String, $adId: String, $acid: String) {
    adTracker(trackingProfileId: $trackingProfileId, adId: $adId, acid: $acid) {
      id
    }
  }
`;
